export {}

declare global {
    interface String {
        capitalize(): string
    }
}
/**
 * @alias capitalize
 * @description Method to Capitalize first letter of a string
 * @returns String
 */
String.prototype.capitalize = function (): string {
    if (this == null) return ''

    const str = String(this).trim()
    if (str.length === 0) return ''

    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}
